<script>
export default {
  computed: {
    userName() {
      const user = this.$store.state.auth.user
      return user ? user.name : null
    },
    isDocument() {
      return this.$route.name === 'document'
    },
  },
  methods: {
    account() {
      if (this.isDocument)
        this.$root.$emit('whant-close-document', '/accountSettings')
      else this.$router.push({ name: 'account' })
    },
    logout() {
      this.$store.dispatch('auth/logOut').then(() => {
        this.$store.commit('data/SET_DICTIONARY_LOADING_STATUS', false)
        this.$router.push('/login')
      })
    },
  },
}
</script>

<template>
  <v-menu
    slot="activator"
    top
    left
    origin="right top"
    transition="scale-transition"
  >
    <v-btn
      slot="activator"
      :loading="!userName"
      flat
    >
      <v-icon>account_circle</v-icon>
      {{ userName }}
    </v-btn>
    <div>
      
      <v-list dense>
        <v-list-tile
          @click="account()"
        >
          <v-list-tile-title>{{ $t('buttons__user_settings') }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          @click="logout()"
        >
          <v-list-tile-title>{{ $t('buttons__logout') }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </div>
  </v-menu>
</template>

<style lang="scss" scoped>
@import '@design';
.item {
  cursor: pointer;
}
.active {
  pointer-events: none;
  background-color: #dfdfdf;
}
</style>
